import { Collapse, Typography } from 'antd'
import { Bot } from 'lucide-react'
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import { t } from '@/config/translations'
import styles from './AgentActivity.module.css'

const { Text } = Typography

export interface AgentActivityProps {
  activity: string
}

export function AgentActivity({ activity }: AgentActivityProps) {
  if (!activity) {
    return null
  }

  const items = [
    {
      key: 'agent-activity',
      label: (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <Bot size={16} />
          <Text strong>{t('agent_activity_title')}</Text>
        </div>
      ),
      children: (
        <div className={styles['activityContent']}>
          <ReactMarkdown remarkPlugins={[remarkGfm]}>{activity}</ReactMarkdown>
        </div>
      ),
    },
  ]

  const collapseClassName = styles['activityCollapse']
  const collapseProps = collapseClassName ? { className: collapseClassName } : {}

  return (
    <div style={{ marginTop: '12px' }}>
      <Collapse size="small" items={items} defaultActiveKey={[]} {...collapseProps} />
    </div>
  )
}
